module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAsBAMAAADyY3eBAAAAAXNSR0IB2cksfwAAAC1QTFRFAAAAIHb/H3X/H3b/H3b/H3b/IHD/H3b/HnX/IHX/H3b/IHj/H3b/H3b/IHj/H2aUfQAAAA90Uk5TAFC/7//PEMCwMNAgr/BAQqtoZwAAAIlJREFUeJxjYFR2gYMwBhAQQQi4uCaAREo6GWDAZQlYkcsGhEgWWJELA0KEDawIWYQBrAhFBKwIRQSsCFlkA1gRkkjJSZAiZBGIY5FFGGvRRaDGYxUpAet3whBxx6sLlzlQs9BE3IeBOU4YIu4khQ/9RDagCHD6ghMNEtjjjpLCQcAPmmgQIfQAAN1cUTyDMRooAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/mpd-library/assets/document-active.png
// module id = 807
// module chunks = 0